import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Класс создает промис и дает возможность управлять этим промисом извне
 * с помощью публичных методов reject и resolve.
 *  */
export var Defer = /*#__PURE__*/_createClass(function Defer() {
  var _this = this;
  _classCallCheck(this, Defer);
  _defineProperty(this, "resolve", void 0);
  _defineProperty(this, "reject", void 0);
  _defineProperty(this, "promise", void 0);
  this.promise = new Promise(function (resolve, reject) {
    _this.resolve = resolve;
    _this.reject = reject;
  });
});